import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid, IconButton, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

import { Form, AgreementsAutocomplete } from "@shared/components";
import { useState } from "react";
import { PopoverComponent } from "../Step2";

export function Step1() {
  const translate = useTranslate();

  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [popoverContent, setPopoverContent] = useState<any>(null);

  const handlePopoverOpen = (event: any, content: any) => {
    setAnchorEl(event.currentTarget);
    setPopoverContent(content);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverContent(null);
  };
  const isPopoverOpen = Boolean(anchorEl);

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("v1/agreement_app_admin.fields.agreement")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="name"
          label={translate("v1/agreement_app_admin.fields.name")}
          fullWidth
          required
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="version"
          label={translate("v1/agreement_app_admin.fields.version")}
          required
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="versionCode"
          label={translate("v1/agreement_app_admin.fields.versionCode")}
          required
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="appBaseUrl"
          label={translate("v1/agreement_app_admin.fields.appBaseUrl")}
          required
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="slug"
          label={translate("v1/agreement_app_admin.fields.slug")}
          instructions={translate("v1/agreement_app_admin.instructions.slug")}
          required
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="bundleIdentifier"
          label={translate("v1/agreement_app_admin.fields.bundleIdentifier")}
          required
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Grid size={{ xs: 12 }}>
          <Typography style={{ fontSize: 14, color: "primary.main" }}>
            {translate("v1/agreement_app_admin.fields.icon")}
            <IconButton
              onClick={(e) =>
                handlePopoverOpen(e, {
                  title: "Icone Adaptativo",
                  description:
                    "O Icone tem que ser dimensionado em 512x512px e deve ser centralizado igual a imagem abaixo, 360x360px.",
                  image: "/images/create-app/adaptive-icon.png",
                })
              }
              size="small"
              sx={{ ml: 1 }}
            >
              <InfoIcon color="primary" />
            </IconButton>
          </Typography>
        </Grid>
        <Form.SinglePhotoPicker name="icon" shape="square" size={180} />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Grid size={{ xs: 12 }}>
          <Typography style={{ fontSize: 14, color: "primary.main" }}>
            {translate("v1/agreement_app_admin.fields.splash")}
          </Typography>
        </Grid>
        <Form.SinglePhotoPicker name="splash" shape="square" size={180} />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="iosPurchaseToken"
          label={translate("v1/agreement_app_admin.fields.iosPurchaseToken")}
          required
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="androidPurchaseToken"
          label={translate(
            "v1/agreement_app_admin.fields.androidPurchaseToken"
          )}
          required
          fullWidth
        />
      </Grid>

      <PopoverComponent
        isPopoverOpen={isPopoverOpen}
        anchorEl={anchorEl}
        handlePopoverClose={handlePopoverClose}
        popoverContent={popoverContent}
      />
    </Grid>
  );
}
